import * as React from "react";
import { cn } from "@/lib/utils";

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  initials: string;
  bgColor?: string;
  size?: number;
  fontSize?: number;
}

function Avatar({ initials, bgColor = "var(--ads-primary)", size = 32, fontSize, className, style, ...props }: AvatarProps) {
  return (
    <div
      role="img"
      aria-label={initials}
      className={cn("grid shrink-0 select-none place-items-center rounded-full font-bold text-white", className)}
      style={{ width: size, height: size, background: bgColor, fontSize: fontSize ?? Math.round(size * 0.36), ...style }}
      {...props}
    >
      {initials}
    </div>
  );
}

export { Avatar };